import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FamilyEditorComponent } from './family-editor/family-editor.component';
import { FamilyEditorMainComponent } from './family-editor-main/family-editor-main.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonComponentModule } from '../common/common.module';
import { ImageCarouselTempModule } from '../common/image-carousel-temp/image-carousel-temp.module';
import { EventsModule } from '../common/events/events.module';
import { MediaCarouselModule } from '../common/media-carousel/media-carousel.module';

@NgModule({
  declarations: [FamilyEditorComponent, FamilyEditorMainComponent],
  imports: [
    CommonModule,
    EventsModule,
    CommonComponentModule,
    FormsModule,
    ImageCarouselTempModule,
    MediaCarouselModule,
    SharedModule
  ],
  exports:[FamilyEditorMainComponent]

})
export class FamilyeditorModule { }

// translation loader moved to SharedModule
